<template>
    <div class="mt30">
    <div class="common-form">预交租金统计</div>
      <el-tabs v-model="activeName2" @tab-click="handleClick2">
        <el-tab-pane label="预交租金笔数" name="yushou"></el-tab-pane>
        <el-tab-pane label="预交租金金额" name="money"></el-tab-pane>
      </el-tabs>
      <div class="d-b-c">
        <div>
          <el-date-picker
            size="small"
            v-model="datePicker2"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate2"
            :picker-options="pickerOptions2"
          ></el-date-picker>
        </div>
      </div>
      <div class="">
        <div class="Echarts"><div id="YzjStatistics"></div></div>
      </div>
    </div>
  </template>
  
  <script>
  import StatisticsApi from '@/api/statistics.js';
  import { formatDate } from '@/utils/DateTime.js'
  export default {
    data() {
      let endDate=new Date();
      let startDate=new Date();
      startDate.setTime(startDate.getTime()- 3600 * 1000 * 24 * 7);
      return {
        /*是否正在加载*/
        loading: true,
        /*类别*/
        activeName2: 'yushou',
        /*时间快捷选项*/
        pickerOptions2: {
          shortcuts: [
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        datePicker2: [formatDate(startDate,'yyyy-MM-dd'),formatDate(endDate,'yyyy-MM-dd')],
        /*数据对象*/
        dataList2: null,
        /*交易统计图表对象*/
        myChart2: null,
        /*图表数据*/
        option2: {
          title: {
            //text: 'ECharts 入门示例'
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis'
          },
          yAxis: {}
        }
      };
    },
    created() {
  
    },
    mounted() {
      this.myEcharts2();
    },
    methods: {
  
      /*切换*/
      handleClick2(e) {
        this.getData2();
        console.log("eeeee",e);
      },
  
      /*选择时间*/
      changeDate2() {
        this.getData2();
      },
  
      /*创建图表对象*/
      myEcharts2() {
        // 基于准备好的dom，初始化echarts实例
        this.myChart2 = this.$echarts.init(document.getElementById('YzjStatistics'));
        /*获取列表*/
        this.getData2();
      },
  
      /*格式数据*/
      createOption2() {
        if (!this.loading) {
          let names = [];
          let xAxis = this.dataList2.days;
          let series1 = [];
          let series2 = [];
          if (this.activeName2 == 'yushou') {

            names = ['预交租金笔数','预交租金金额'];
            this.dataList2.data.forEach(item => {
              series1.push(item.total_num);
            });
          } else if (this.activeName2 == 'money') {
            names = ['预交租金笔数','预交租金金额'];
            this.dataList2.data.forEach(item => {
              series2.push(item.total_num);
            });
          }
  
          // 指定图表的配置项和数据
          this.option2.xAxis = {
            type: 'category',
            boundaryGap: false,
            data: xAxis
          };
          this.option2.color=["red", "#409EFF"];
          this.option2.legend = {
            data: [{ name: names[0], color: '#ccc' }, { name: names[1] }]
          };
          this.option2.series = [
            {
              name: names[0],
              type: 'line',
              data: series1,
              lineStyle: {
                color: 'red'
              }
            },
            {
              name: names[1],
              type: 'line',
              data: series2,
              lineStyle: {
                color: '#409EFF'
              }
            }
          ];
  
          this.myChart2.setOption(this.option2);
          this.myChart2.resize();
        }
      },
  
      /*获取列表*/
      getData2() {
        let self = this;
        self.loading = true;
        StatisticsApi.getyushou(
          {
            search_time: self.datePicker2,
            type: self.activeName2
          },
          true
        )
          .then(res => {
            self.dataList2 = res.data;
            self.loading = false;
            self.createOption2();
            console.log("预收租金统计",res.data);
          })
          .catch(error => {});
      }
    }
  };
  </script>
  
  <style>
  .Echarts {
    box-sizing: border-box;
  }
  .Echarts > div {
    width: 100%;
    height: 400px;
    box-sizing: border-box;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/statistics/sales/part/YzjStatistics.vue